import { render, staticRenderFns } from "./KlarnaModalLegacy.vue?vue&type=template&id=69f4f884&"
import script from "./KlarnaModalLegacy.vue?vue&type=script&lang=js&"
export * from "./KlarnaModalLegacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports